/* eslint-disable no-case-declarations */
import { FEE_TYPES } from './constants';
import { CreatePortfolioState } from './CreatePortfolioManager.types';

export const LOCAL_STORAGE_KEY = 'CreatePortfolio';

export const initialState = (): CreatePortfolioState => {
    const localStorageData = sessionStorage.getItem(LOCAL_STORAGE_KEY);

    return localStorageData ? JSON.parse(localStorageData) : {
        selectedProductId: 0,
        applications: {},
        isResumeCase: false,
        uploadedAdvisoryDocument: null,
    };
};

export const CreatePortfolioManagerReducer = (state: CreatePortfolioState = initialState(), action: { type: any; payload?: any }) : CreatePortfolioState => {
    switch (action.type) {
        case 'setProductData':
            return {
                ...state,
                readyToNavigate: true,
                applications: {
                    ...state.applications,
                    [String(state.currentInvestmentApplicationId)]: {
                        ...state.applications[String(state.currentInvestmentApplicationId)],
                        investmentDescription: {
                            ...state.applications[String(state.currentInvestmentApplicationId)]?.investmentDescription,
                            productExternalId: action.payload.productExternalId,
                            productId: action.payload.productId,
                        },
                    },
                },
            };
        case 'setAdvisoryProcessType':
            return {
                ...state,
                readyToNavigate: true,
                advisoryProcessType: action.payload,
            };
        case 'setAdvisoryProcess':
            return {
                ...state,
                readyToNavigate: true,
                isAdvisoryProcess: action.payload,
            };
        case 'setAdvisoryData':
            return {
                ...state,
                readyToNavigate: true,
                uploadedAdvisoryDocument: null,
                advisoryData: action.payload,
            };
        case 'setUploadedAdvisoryDocument':
            return {
                ...state,
                readyToNavigate: true,
                uploadedAdvisoryDocument: action.payload,
                advisoryProcessInProgress: false,
                advisoryData: {},
            };
        case 'setConnectionGroupId':
            return {
                ...state,
                readyToNavigate: true,
                applications: {
                    ...state.applications,
                    [String(state.currentInvestmentApplicationId)]: {
                        ...state.applications[String(state.currentInvestmentApplicationId)],
                        contactGroupId: action.payload,
                    },
                },
            };
        case 'lockNavigation':
            return {
                ...state,
                readyToNavigate: false,
            };
        case 'unlockNavigation':
            return {
                ...state,
                readyToNavigate: true,
            };
        case 'setShouldInitiateAdvisory':
            return {
                ...state,
                readyToNavigate: true,
                shouldInitiateAdvisoryProcess: action.payload,
            };
        case 'saveInvestorProfileClient':
            return {
                ...state,
                investorProfileClientId: action.payload,
            };
        case 'saveRecommendedStrategy':
            return {
                ...state,
                readyToNavigate: true,
                applications: {
                    ...state.applications,
                    [String(state.currentInvestmentApplicationId)]: {
                        ...state.applications[String(state.currentInvestmentApplicationId)],
                        ...action.payload,
                    },
                },
            };
        case 'resumeShoppingCard':
            return {
                ...state,
                readyToNavigate: true,
                is3B: action.payload.is3B,
                shouldInitiateAdvisoryProcess: action.payload.shouldInitiateAdvisoryProcess,
                advisoryData: action.payload.advisoryData,
                advisoryProcessInProgress: action.payload.advisoryProcessInProgress,
                currentInvestmentApplicationId: action.payload.investmentApplicationId,
                ...{ investorProfileClientId: action.payload.investorProfileClientId },
                applications: {
                    ...state.applications,
                    ...action.payload.applications.reduce((akku, application) => {
                        akku[application.investmentApplicationId] = {
                            ...application,
                        };

                        return akku;
                    }, {}),
                },
            };
        case 'saveInvestmentApplicationData':
            return {
                ...state,
                readyToNavigate: true,
                currentInvestmentApplicationId: action.payload.investmentApplicationId,
                applications: {
                    ...state.applications,
                    [action.payload.investmentApplicationId]: {
                        ...state.applications[action.payload.investmentApplicationId],
                        ...action.payload,
                    },
                },
            };
        case 'removeInvestmentApplicationData':
            const applications = { ...state.applications };

            delete applications[action.payload?.investmentApplicationId];

            const applicationsKeys = Object.keys(applications)?.filter(key => key !== 'undefined');
            const currentId = applicationsKeys.length > 0 ? +applicationsKeys[applicationsKeys.length - 1] : null;

            if (currentId) {
                return {
                    ...state,
                    currentInvestmentApplicationId: currentId,
                    readyToNavigate: false,
                    applications,
                };
            }

            return { ...state };

        case 'saveCurrentInvestmentApplicationId':
            return {
                ...state,
                currentInvestmentApplicationId: action.payload.investmentApplicationId,
            };
        case 'clearProductSetup':
            return {
                ...state,
                isProductSetup: false,
            };
        case 'startProductSetup':
            return {
                ...state,
                readyToNavigate: true,
                currentInvestmentApplicationId: action.payload.investmentApplicationId,
                isProductSetup: true,
                applications: {
                    ...state.applications,
                    [action.payload.investmentApplicationId]: {
                        ...state.applications[action.payload.investmentApplicationId],
                        ...action?.payload?.applicationData,
                    },
                },
            };
        case 'setProductId':
            return {
                ...state,
                readyToNavigate: true,
                selectedProductId: action.payload,
            };
        case 'setAdvisoryProcessInProgress':
            return {
                ...state,
                readyToNavigate: true,
                advisoryProcessInProgress: action.payload,
            };
        case 'startZIVVChangePlanAdvisoryProcess':
            return {
                ...state,
                readyToNavigate: true,
                changePlan: true,
                portfolioId: action.payload?.portfolioId,
                is3B: undefined,
                shouldInitiateAdvisoryProcess: 1,
                advisoryData: {},
                advisoryProcessInProgress: false,
                currentInvestmentApplicationId: undefined,
                ...{ investorProfileClientId: action.payload.investorProfileClientId },
                applications: {
                    undefined: {
                        contactGroupId: action.payload.contactGroupId,
                        investmentDescription: {
                            productId: 999999,
                        },
                    },
                },
            };

        case 'setContinueDisabledFromShoppingCart':
            return {
                ...state,
                continueDisabledFromShoppingCart: action?.payload,
            };

        case 'setContainerApplications':
            return {
                ...state,
                applications: {
                    ...state.applications,
                    ...action?.payload?.applications?.reduce((akku, application) => {
                        akku[application.investmentApplicationId] = {
                            ...application,
                        };

                        return akku;
                    }, {}),
                },
            };

        case 'setDefaultAssetManagementFee':
            return {
                ...state,
                applications: {
                    ...state.applications,
                    [action.payload.investmentApplicationId]: {
                        ...state.applications[action.payload.investmentApplicationId],
                        investmentDescription: {
                            ...state.applications[action.payload.investmentApplicationId].investmentDescription,
                            fees: state.applications[action.payload.investmentApplicationId].investmentDescription?.fees?.map(fee => {
                                if (fee.feeType === FEE_TYPES.asset) {
                                    return action?.payload?.fee;
                                }

                                return fee;
                            }),
                        },
                    },
                },
            };
        default:
            return state;
    }
};
